<!-- <script src="js/flexible.js"></script>
<script src="js/jquery.js"></script>
<script src="js/echarts.min.js"></script>
<script src="js/index.js"></script>
<script src="js/china.js"></script>
<script src="js/myMap.js"></script> -->
<!--
<template>
  <body id="bodytest">
    <header>
      <h1>大白数字家医隐私协议</h1>
      <div class="subtitle">您的健康数据安全是我们的首要任务</div>
      <div class="date-info">
        生效日期：2025年6月27日 | 最后更新：2025年6月27日
      </div>
    </header>

    <div class="toc">
      <h2>目录</h2>
      <ul>
        <li><a href="#section1">一、我们收集的信息类型</a></li>
        <li><a href="#section2">二、权限声明</a></li>
        <li><a href="#section3">三、信息使用方式与目的</a></li>
        <li><a href="#section4">四、数据存储与安全</a></li>
        <li><a href="#section5">五、第三方共享规则</a></li>
        <li><a href="#section6">六、您的权利</a></li>
        <li><a href="#section7">七、儿童特别保护</a></li>
        <li><a href="#section8">八、第三方插件管理</a></li>
        <li><a href="#section9">九、协议更新</a></li>
      </ul>
    </div>

    <div class="section" id="section1">
      <h2>一、我们收集的信息类型</h2>

      <h3>健康设备数据</h3>
      <p>
        通过您授权的可穿戴设备/健康硬件收集：心率、血压、血氧、睡眠质量、步数、体温、ECG等。
      </p>

      <h3>账户信息</h3>
      <p>手机号、昵称、性别、年龄、身高、体重等。</p>

      <h3>服务使用数据</h3>
      <p>设备型号、IP地址、操作日志、功能使用频率等。</p>
    </div>

    <div class="section" id="section2">
      <h2>二、权限声明</h2>

      <h3>网络权限</h3>
      <p>我们需要获取您的网络状态以保证应用可以正常运行</p>

      <h3>获取联系人权限</h3>
      <p>需要获取您的联系人信息，以便填写紧急联系人</p>

      <h3>访问照片,音频，文件权限</h3>
      <p>存储信息。</p>

      <h3>录音权限</h3>
      <p>需要获取您的录音权限，以便咨询</p>

      <h3>获取应用状态权限</h3>
      <p>需要获取应用状态，以便保证数据上传成功</p>

      <h3>蓝牙连接</h3>
      <p>需要获取蓝牙连接权限，以便连接蓝牙设备</p>
    </div>

    <div class="section" id="section3">
      <h2>三、信息使用方式与目的</h2>

      <table>
        <thead>
          <tr>
            <th>信息类别</th>
            <th>使用场景</th>
            <th>法律依据</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>健康设备数据</strong></td>
            <td>生成健康报告/实时异常预警（如心率骤降时手表震动+APP推送）</td>
            <td>履行合同/保护生命健康</td>
          </tr>
          <tr>
            <td><strong>运动营养数据</strong></td>
            <td>生成运动计划与膳食建议</td>
            <td>用户明示同意</td>
          </tr>
          <tr>
            <td><strong>异常体征数据</strong></td>
            <td>启动电话主动关怀服务（需用户提前授权紧急联系人）</td>
            <td>用户同意/重大公共利益</td>
          </tr>
          <tr>
            <td><strong>去标识化数据</strong></td>
            <td>医学研究模型训练（如睡眠质量与季节相关性分析）</td>
            <td>科研公益目的</td>
          </tr>
        </tbody>
      </table>

      <div class="highlight-box">
        <p>
          健康分析报告<strong>非医疗诊断结论</strong>，仅供参考。用户需保证设备数据采集符合自身健康状况（如佩戴心脏起搏器者禁用ECG功能）。
        </p>
      </div>
    </div>

    <div class="section" id="section4">
      <h2>四、数据存储与安全</h2>

      <h3>阿里云安全存储认证</h3>
      <p>
        所有数据通过阿里云加密存储于中国大陆数据中心，未经批准绝不跨境传输。
      </p>

      <h3>三重安全防护体系</h3>
      <div class="security-grid">
        <div class="security-layer">
          <h4>传输层</h4>
          <p>HTTPS+SSL 256位加密</p>
        </div>
        <div class="security-layer">
          <h4>存储层</h4>
          <p>阿里云KMS密钥管理+分布式存储隔离</p>
        </div>
        <div class="security-layer">
          <h4>权限控制</h4>
          <p>RBAC角色分级访问+操作留痕审计</p>
        </div>
      </div>

      <h3>数据留存期限</h3>
      <ul class="retention-list">
        <li>健康原始数据：自账号注销后<strong>30天自动销毁</strong></li>
        <li>分析报告：匿名化后作为科研样本保存（无法关联个人身份）</li>
      </ul>
    </div>

    <div class="section" id="section5">
      <h2>五、第三方共享规则</h2>
      <p>我们仅在以下情况与第三方共享您的信息：</p>
      <ul class="retention-list">
        <li>获得您的明确授权</li>
        <li>为提供您要求的服务所必需</li>
        <li>基于法律要求或政府部门的合法要求</li>
        <li>为保护用户或公众的人身财产安全</li>
      </ul>
      <p>
        与第三方共享时，我们会签订严格的数据保护协议，要求其采取不低于本协议的保护措施。
      </p>
    </div>

    <div class="section" id="section6">
      <h2>六、您的权利</h2>
      <p>您对自己的个人信息享有以下权利：</p>
      <ul class="retention-list">
        <li>访问、查阅、复制您的个人信息</li>
        <li>更正不准确的个人信息</li>
        <li>删除您的个人信息</li>
        <li>撤回已同意的授权</li>
        <li>获取个人信息副本</li>
        <li>注销账户</li>
      </ul>
      <p>您可以通过APP内设置或联系客服行使上述权利。</p>
    </div>

    <div class="section" id="section7">
      <h2>七、儿童特别保护</h2>
      <p>
        我们的服务不面向14周岁以下儿童。如果我们发现收集了儿童个人信息，会立即删除相关数据。
      </p>
      <p>
        监护人如发现儿童未经同意提供了个人信息，请通过zch888@139.com联系我们，我们将采取措施予以删除。
      </p>
    </div>

    <div class="section" id="section8">
      <h2>八、第三方插件管理</h2>
      <p>
        1、极光推送SDK(ipushSDK):提供信息和消息的推送服务，极光SDK需要收集你的设备Mac地址，获取AndroidID、IMEI，SIM卡信息，Wi-Fi
        SSID，Wi-Fi
        BSSID和安装列表的行为，以及获取已安装的应用信息，隐私协议地址:https://www.jiguang.cn/license/privacy
      </p>
    </div>

    <div class="section" id="section9">
      <h2>九、协议更新</h2>
      <p>
        我们可能适时更新本隐私协议。更新后，我们会通过APP内推送、网站公告等方式通知您。
      </p>
      <p>
        若您继续使用我们的服务，即表示同意更新后的协议。您可以在APP"设置-隐私协议"中查看最新版本。
      </p>
      <p>重大变更时，我们会提前30天通知您，并重新获取您的同意。</p>
    </div>

    <div class="consent-box">
      <h3>隐私协议确认</h3>
      <p>
        我已阅读并理解《大白数字家医隐私协议》的全部内容，同意按照此协议处理我的个人信息。
      </p>
      <div class="consent-actions">
        <p>请登录APP后于"账户设置-隐私协议"中完成最终确认</p>
      </div>
    </div>

    <footer>
      <h2>联系我们</h2>
      <div class="contact-methods">
        <div class="contact-item">
          <h3>隐私保护官邮箱</h3>
          <p>zch888@139.com</p>
        </div>
        <div class="contact-item">
          <h3>客服电话</h3>
          <p>15895887135（工作日9:00-18:00）</p>
        </div>

        <div class="contact-item">
          <h3>在线客服</h3>
          <p>APP内「我的-帮助中心」</p>
        </div>
        <div class="contact-item">
          <h3>公司相关</h3>
          <p>大白主动健康科技（南京）有限公司</p>
          <p>南京市鼓楼区汉中门大街301号外包服务大厦AB座12层1212室</p>
        </div>
      </div>
      <div class="legal-notes">
        <h3>法律声明要点</h3>
        <ul>
          <li>健康分析报告非医疗诊断结论，仅供参考</li>
          <li>用户需保证设备数据采集符合自身健康状况</li>
          <li>因用户主动共享密码导致的数据泄露，平台不承担责任</li>
        </ul>
      </div>
    </footer>
  </body>
</template> -->

<template>
  <body id="bodytest">
    <header>
      <h1>大白数字家医用户协议</h1>
      <div class="subtitle">您的健康数据安全是我们的首要任务</div>
      <div class="date-info">
        生效日期：2025年6月27日 | 最后更新：2025年6月27日
      </div>
    </header>

    <div class="toc">
      <h2>目录</h2>
      <ul>
        <li><a href="#section1">一、我们收集的信息类型</a></li>
        <li><a href="#section2">二、权限声明</a></li>
        <li><a href="#section3">三、信息使用方式与目的</a></li>
        <li><a href="#section4">四、数据存储与安全</a></li>
        <li><a href="#section5">五、第三方共享规则</a></li>
        <li><a href="#section6">六、您的权利</a></li>
        <li><a href="#section7">七、儿童特别保护</a></li>
        <li><a href="#section8">八、第三方插件管理</a></li>
        <li><a href="#section9">九、协议更新</a></li>
      </ul>
    </div>

    <div class="section" id="section1">
      <h2>一、我们收集的信息类型</h2>

      <h3>健康设备数据</h3>
      <p>
        通过您授权的可穿戴设备/健康硬件收集：心率、血压、血氧、睡眠质量、步数、体温、ECG等。
      </p>

      <h3>账户信息</h3>
      <p>手机号、昵称、性别、年龄、身高、体重等。</p>

      <h3>服务使用数据</h3>
      <p>设备型号、IP地址、操作日志、功能使用频率等。</p>
    </div>

    <div class="section" id="section2">
      <h2>二、权限声明</h2>

      <h3>网络权限</h3>
      <p>我们需要获取您的网络状态以保证应用可以正常运行</p>

      <h3>获取联系人权限</h3>
      <p>需要获取您的联系人信息，以便填写紧急联系人</p>

      <h3>访问照片,音频，文件权限</h3>
      <p>存储信息。</p>

      <h3>录音权限</h3>
      <p>需要获取您的录音权限，以便咨询</p>

      <h3>获取应用状态权限</h3>
      <p>需要获取应用状态，以便保证数据上传成功</p>

      <h3>蓝牙连接</h3>
      <p>需要获取蓝牙连接权限，以便连接蓝牙设备</p>
    </div>

    <div class="section" id="section3">
      <h2>三、信息使用方式与目的</h2>

      <table>
        <thead>
          <tr>
            <th>信息类别</th>
            <th>使用场景</th>
            <th>法律依据</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>健康设备数据</strong></td>
            <td>生成健康报告/实时异常预警（如心率骤降时手表震动+APP推送）</td>
            <td>履行合同/保护生命健康</td>
          </tr>
          <tr>
            <td><strong>运动营养数据</strong></td>
            <!-- <td>定制个性化运动计划与膳食建议</td> -->
            <td>生成运动计划与膳食建议</td>
            <td>用户明示同意</td>
          </tr>
          <tr>
            <td><strong>异常体征数据</strong></td>
            <td>启动电话主动关怀服务（需用户提前授权紧急联系人）</td>
            <td>用户同意/重大公共利益</td>
          </tr>
          <tr>
            <td><strong>去标识化数据</strong></td>
            <td>医学研究模型训练（如睡眠质量与季节相关性分析）</td>
            <td>科研公益目的</td>
          </tr>
        </tbody>
      </table>

      <div class="highlight-box">
        <p>
          健康分析报告<strong>非医疗诊断结论</strong>，仅供参考。用户需保证设备数据采集符合自身健康状况（如佩戴心脏起搏器者禁用ECG功能）。
        </p>
      </div>
    </div>

    <div class="section" id="section4">
      <h2>四、数据存储与安全</h2>

      <h3>阿里云安全存储认证</h3>
      <p>
        所有数据通过阿里云加密存储于中国大陆数据中心，未经批准绝不跨境传输。
      </p>

      <h3>三重安全防护体系</h3>
      <div class="security-grid">
        <div class="security-layer">
          <h4>传输层</h4>
          <p>HTTPS+SSL 256位加密</p>
        </div>
        <div class="security-layer">
          <h4>存储层</h4>
          <p>阿里云KMS密钥管理+分布式存储隔离</p>
        </div>
        <div class="security-layer">
          <h4>权限控制</h4>
          <p>RBAC角色分级访问+操作留痕审计</p>
        </div>
      </div>

      <h3>数据留存期限</h3>
      <ul class="retention-list">
        <li>健康原始数据：自账号注销后<strong>30天自动销毁</strong></li>
        <li>分析报告：匿名化后作为科研样本保存（无法关联个人身份）</li>
      </ul>
    </div>

    <div class="section" id="section5">
      <h2>五、第三方共享规则</h2>
      <p>我们仅在以下情况与第三方共享您的信息：</p>
      <ul class="retention-list">
        <li>获得您的明确授权</li>
        <li>为提供您要求的服务所必需</li>
        <li>基于法律要求或政府部门的合法要求</li>
        <li>为保护用户或公众的人身财产安全</li>
      </ul>
      <p>
        与第三方共享时，我们会签订严格的数据保护协议，要求其采取不低于本协议的保护措施。
      </p>
    </div>

    <div class="section" id="section6">
      <h2>六、您的权利</h2>
      <p>您对自己的个人信息享有以下权利：</p>
      <ul class="retention-list">
        <li>访问、查阅、复制您的个人信息</li>
        <li>更正不准确的个人信息</li>
        <li>删除您的个人信息</li>
        <li>撤回已同意的授权</li>
        <li>获取个人信息副本</li>
        <li>注销账户</li>
      </ul>
      <p>您可以通过APP内设置或联系客服行使上述权利。</p>
    </div>

    <div class="section" id="section7">
      <h2>七、儿童特别保护</h2>
      <p>
        我们的服务不面向14周岁以下儿童。如果我们发现收集了儿童个人信息，会立即删除相关数据。
      </p>
      <p>
        监护人如发现儿童未经同意提供了个人信息，请通过zch888@139.com联系我们，我们将采取措施予以删除。
      </p>
    </div>

    <div class="section" id="section8">
      <h2>八、第三方插件管理</h2>
      <p>
        1、极光推送SDK(ipushSDK):提供信息和消息的推送服务，极光SDK需要收集你的设备Mac地址，获取AndroidID、IMEI，SIM卡信息，Wi-Fi
        SSID，Wi-Fi
        BSSID和安装列表的行为，以及获取已安装的应用信息，隐私协议地址:https://www.jiguang.cn/license/privacy
      </p>
    </div>

    <div class="section" id="section9">
      <h2>九、协议更新</h2>
      <p>
        我们可能适时更新本用户协议。更新后，我们会通过APP内推送、网站公告等方式通知您。
      </p>
      <p>
        若您继续使用我们的服务，即表示同意更新后的协议。您可以在APP"登陆界面/注册界面/刚打开应用的弹窗"中查看最新版本。
      </p>
      <p>重大变更时，我们会提前30天通知您，并重新获取您的同意。</p>
    </div>

    <div class="consent-box">
      <h3>用户协议确认</h3>
      <p>
        我已阅读并理解《大白数字家医用户协议》的全部内容，同意按照此协议处理我的个人信息。
      </p>
      <div class="consent-actions">
        <p>请登录APP后于"登陆界面/注册界面/刚打开应用的弹窗"中完成最终确认</p>
      </div>
    </div>

    <footer>
      <h2>联系我们</h2>
      <div class="contact-methods">
        <div class="contact-item">
          <h3>隐私保护官邮箱</h3>
          <p>zch888@139.com</p>
        </div>
        <div class="contact-item">
          <h3>客服电话</h3>
          <p>15895887135（工作日9:00-18:00）</p>
        </div>

        <div class="contact-item">
          <h3>在线客服</h3>
          <p>APP内「我的-帮助中心」</p>
        </div>
        <div class="contact-item">
          <h3>公司相关</h3>
          <p>大白主动健康科技（南京）有限公司</p>
          <p>南京市鼓楼区汉中门大街301号外包服务大厦AB座12层1212室</p>
        </div>
      </div>
      <div class="legal-notes">
        <h3>法律声明要点</h3>
        <ul>
          <li>健康分析报告非医疗诊断结论，仅供参考</li>
          <li>用户需保证设备数据采集符合自身健康状况</li>
          <li>因用户主动共享密码导致的数据泄露，平台不承担责任</li>
        </ul>
      </div>
    </footer>
  </body>
</template>

<script>
export default {
  data() {
    return {
      effectiveDate: "2025年6月27日",
      lastUpdated: "2025年6月27日",
      showBackToTop: false,
      sections: [
        { title: "一、我们收集的信息类型" },
        { title: "二、信息使用方式与目的" },
        { title: "三、数据存储与安全" },
        { title: "四、第三方共享规则" },
        { title: "五、您的权利" },
        { title: "六、儿童特别保护" },
        { title: "七、协议更新" },
      ],
      agreementStatus: null,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    acceptAgreement() {
      this.agreementStatus = {
        message: "您已成功同意隐私协议！",
        icon: "fas fa-check-circle",
        type: "success-status",
      };
    },
    declineAgreement() {
      this.agreementStatus = {
        message: "您需要同意隐私协议才能继续使用我们的服务",
        icon: "fas fa-exclamation-triangle",
        type: "error-status",
      };
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 300;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
#app {
  height: max-content;
}

#bodytest {
  height: 100vh;
  overflow-y: auto;
}

body {
  background-color: #f0f8ff;
  color: #333;
  line-height: 1.6;
  padding: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background: #fff;
  border: 1px solid #ddd;
}

th,
td {
  padding: 12px 15px;
  text-align: left;
  border: 1px solid #ddd;
}
</style>

<style>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

/* body {
  background-color: #f0f8ff;
  color: #333;
  line-height: 1.6;
  padding: 20px;
} */

.container {
  max-width: 1000px;
  margin: 0 auto;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

header {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #0066cc;
}

h1 {
  font-size: 2.2rem;
  color: #0066cc;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 15px;
}

.date-info {
  color: #666;
  font-size: 0.95rem;
}

.toc {
  background: #f5f9ff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
}

.toc h2 {
  color: #0066cc;
  margin-bottom: 15px;
  font-size: 1.4rem;
}

.toc ul {
  list-style-type: none;
}

.toc li {
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
}

.toc li:before {
  content: "•";
  position: absolute;
  left: 0;
  color: #0066cc;
  font-weight: bold;
}

.toc a {
  color: #0066cc;
  text-decoration: none;
}

.toc a:hover {
  text-decoration: underline;
}

.section {
  margin-bottom: 40px;
}

.section h2 {
  color: #0066cc;
  font-size: 1.6rem;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.section h3 {
  color: #1a3a5a;
  font-size: 1.3rem;
  margin: 25px 0 15px;
}

p {
  margin-bottom: 15px;
  line-height: 1.7;
}

/* table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background: #fff;
  border: 1px solid #ddd;
}

th,
td {
  padding: 12px 15px;
  text-align: left;
  border: 1px solid #ddd;
} */

th {
  background-color: #e6f2ff;
  color: #0066cc;
  font-weight: 600;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

.highlight-box {
  background: #fffde7;
  border-left: 4px solid #ffcc00;
  padding: 15px;
  margin: 20px 0;
  border-radius: 0 4px 4px 0;
}

.security-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin: 20px 0;
}

.security-layer {
  background: #f0f8ff;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #cce0ff;
}

.security-layer h4 {
  color: #1a3a5a;
  margin-bottom: 10px;
}

.retention-list {
  list-style-type: none;
  margin: 20px 0;
}

.retention-list li {
  margin-bottom: 15px;
  padding-left: 25px;
  position: relative;
}

.retention-list li:before {
  content: "•";
  position: absolute;
  left: 10px;
  color: #0066cc;
  font-weight: bold;
}

.consent-box {
  background: #f0f8ff;
  padding: 25px;
  border-radius: 8px;
  margin: 30px 0;
  text-align: center;
  border: 1px solid #cce0ff;
}

.consent-box h3 {
  color: #0066cc;
  margin-bottom: 20px;
}

.consent-actions {
  margin-top: 20px;
}

footer {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 2px solid #0066cc;
}

footer h2 {
  color: #0066cc;
  text-align: center;
  margin-bottom: 25px;
}

.contact-methods {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.contact-item {
  background: #f0f8ff;
  padding: 20px;
  border-radius: 8px;
}

.contact-item h3 {
  color: #1a3a5a;
  margin-bottom: 10px;
}

.legal-notes {
  background: #fffde7;
  padding: 20px;
  border-radius: 8px;
  margin-top: 30px;
}

.legal-notes h3 {
  color: #1a3a5a;
  margin-bottom: 15px;
}

.legal-notes ul {
  list-style-type: none;
}

.legal-notes li {
  margin-bottom: 10px;
  padding-left: 25px;
  position: relative;
}

.legal-notes li:before {
  content: "•";
  position: absolute;
  left: 10px;
  color: #0066cc;
  font-weight: bold;
}

@media (max-width: 768px) {
  .container {
    padding: 20px;
  }

  h1 {
    font-size: 1.8rem;
  }

  .section h2 {
    font-size: 1.4rem;
  }

  .section h3 {
    font-size: 1.2rem;
  }

  .security-grid,
  .contact-methods {
    grid-template-columns: 1fr;
  }
}
</style>
